import React from 'react'
import { Row, Col } from 'react-bootstrap'

function ExclusiveDeals() {
    return (
        <Row className="p-4">
            <Col><img className="img-fluid" src="https://i.ibb.co/BrV9nDm/en-cat-01.png" alt="" /></Col>
            <Col><img className="img-fluid" src="https://i.ibb.co/QNfPffr/en-cat-02.png" alt="" /></Col>
        </Row>
    )
}

export default ExclusiveDeals
